export default "__VITE_ASSET__c9bcc360__"